module.exports = "/packs/course-small-web-marketing-5a914d5e0ea869335d979f349e03cc15.png";